module.exports = [
  "APS FINANCIAL LTD",
  "BANK OF SCOTLAND PLC",
  "BARCLAYS BANK UK PLC",
  "HALIFAX",
  "HSBC UK BANK PLC",
  "LLOYDS BANK PLC",
  "METRO BANK PLC",
  "MONESE",
  "MONZO BANK LIMITED",
  "MONZO",
  "NATIONAL WESTMINSTER BANK PLC",
  "NATIONWIDE BUILDING SOCIETY",
  "NATWEST",
  "PREPAY TECHNOLOGIES LTD",
  "REVOLUT (MODULR FS LTD)",
  "REVOLUT",
  "SANTANDER UK PLC",
  "STARLING BANK LIMITED",
  "TSB",
  "TSB BANK PLC",
  "VIRGIN MONEY PLC",
  "WIRECARD CARD SOLUTIONS LTD",
  'Other',
];


//////////////////
// WEBPACK FOOTER
// ../server/constants/bankNames.js
// module id = 1187
// module chunks = 0